import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MakeGetRequest from "../utils/MakeGetRequest";
import makePostRequest from "../utils/makePostRequest";
import SmallTitleText from "../SmallTitleText";
import FormInputField from "../FormInputField";
import FormAutoComplete from "../FormAutoComplete";

const CreateBandForm = () => {
  const navigate = useNavigate();
  const formRef = useRef(null);
  const nameRef = useRef(null);
  const genreRef = useRef(null);
  const constellationRef = useRef(null);
  const activeRef = useRef(null);
  const cityRef = useRef(null);

  const {
    data: formData,
    error: formError,
    loading: formLoading,
  } = MakeGetRequest({ route: "form_data_create_new_band", forceToken: true });

  const [postLoading, setPostLoading] = useState(false);
  const [postSuccessMsg, setPostSuccessMsg] = useState("");
  const [postError, setPostError] = useState("");

  const editBandUrl = "/userprofile/band?slug=";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formRef.current.checkValidity()) {
      // Proceed with form submission
      const formElements = formRef.current.elements;
      const submittedData = {};
      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];
        if (element.name) {
          submittedData[element.name] = element.value;
        }
      }
      setPostLoading(true);
      makePostRequest("create_new_band", submittedData)
        .then((response) => {
          setPostLoading(false);
          if (response.error) {
            setPostError(response.error);
          } else {
            // handle successful response
            const slug = response.data.slug;
            setPostSuccessMsg(
              "Musikprojket är skapat, du flyttas snart vidare"
            );
            setTimeout(() => {
              navigate(editBandUrl + slug); // Redirect after 2 seconds
            }, 2000);
          }
        })
        .catch((error) => {
          // handle errors
          const errorMessage =
            error?.response?.data?.error_message ||
            "Ett oväntat fel inträffade.";
          setPostError(errorMessage);
          setPostLoading(false);
        });
    } else {
      // form error
      formRef.current.reportValidity();
    }
  };

  if (formLoading) {
    return <div>Loading form data...</div>;
  }

  if (!formLoading) {
    return (
      <>
        <div className="p-4">
          <div className="pb-4">
            <SmallTitleText text="Skapa nytt musikprojekt" />
          </div>

          <form ref={formRef} onSubmit={handleSubmit} noValidate>
            {formData && (
              <>
                <FormInputField
                  type="text"
                  name="name"
                  ref={nameRef}
                  label="Namn"
                  bottomLabel="Det går inte att ändra detta senare"
                  placeholder="Band/artist-namn"
                  required={true}
                />
                {/* 
                <FormAutoComplete
                  name="location"
                  label="Stad"
                  required={true}
                  items={formData.cities}
                  ref={cityRef}
                  demo=
                />
                */}
                <FormInputField
                  type="checkbox"
                  name="active"
                  ref={activeRef}
                  label="Är du/ni aktiva nu?"
                  checked={true}
                />
                <FormInputField
                  type="select"
                  name="constellation_type"
                  ref={constellationRef}
                  label="Konstellations typ"
                  disabledChoiseText="Vad är du/ni för typ av konstellation?"
                  items={formData.constellations}
                  itemName="type"
                  required={true}
                />
                <FormInputField
                  type="select"
                  name="genre_main"
                  ref={genreRef}
                  label="Genre"
                  disabledChoiseText="Vilken är er huvudgenre?"
                  items={formData.genres}
                  itemName="genre"
                  required={true}
                />
                {postSuccessMsg && (
                  <p className="font-semibold text-success my-2">
                    {postSuccessMsg}
                  </p>
                )}
                {postError && (
                  <h4 className="font-semibold text-error mb-3 pl-1">
                    Fel, {postError}
                  </h4>
                )}
                {!postLoading ? (
                  <button className="btn btn-primary" type="submit">
                    Skapa
                  </button>
                ) : (
                  <button className="btn btn-disabled" disabled type="submit">
                    Skapa
                  </button>
                )}
              </>
            )}
          </form>
        </div>
      </>
    );
  }
};

export default CreateBandForm;
